import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from "recharts";
import './BarChartItem.scss';

const BarChartItem = ({ data, colors, title, height }) => {
  return (
    <div className="bar-chart-container">
      <div className="bar-chart-title">
        <h2>{title}</h2>
      </div>
      <div
        className="bar-chart-content"
        style={{ height: `${height}`, width: `99%` }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            barCategoryGap="10%"
            margin={{ top: 10, right: 5, left: 10, bottom: 40 }}
            barGap="15px">
            <CartesianGrid vertical={false} strokeDasharray="0" />
            <XAxis
              tick={{ fontSize: 12, fontFamily: "IRANSans-Bold", dy: 15 }}
              interval={0}
              angle={0}
              dataKey="name"
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 12, fontFamily: "IRANSans-Bold" }}
              dx={-40}
              tickCount={5}
              axisLine={false}
              tickLine={false}
            />
            <Bar dataKey="uv" barSize={3.5}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarChartItem;